"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_play__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fa7fa6d6-e766-4879-8591-74d4436cc0e4",
    "data-name": "Apps_ic",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "3a51d2c5-a6d7-4bb4-9d36-4d1c98564071",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "1d9f1c16-9270-471e-acb6-27b8d0fb7285",
    x1: 321.52,
    y1: -1277.6,
    x2: 321.52,
    y2: -1210.41,
    gradientTransform: "matrix(0.56, -0.56, 0.71, 0.71, 825.43, 1191.62)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "play-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "daeacc10-d11e-44fb-8e1c-56d96f0995c3",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "65052cae-edc5-447c-a616-12fbbb658203",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "81178f45-755b-4746-b8dd-2ee7cba63d54",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c79ceaa1-d931-456b-81fb-579f71752e62",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "73178cfd-8a4b-41ec-ba7d-a48dd55941d9",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 160,
    height: 160,
    rx: 80,
    ry: 80,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96,174h0A80.23,80.23,0,0,1,16,95c0,.33,0,.66,0,1h0a80.24,80.24,0,0,0,80,80h0a80.24,80.24,0,0,0,80-80h0c0-.34,0-.67,0-1A80.23,80.23,0,0,1,96,174Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3a51d2c5-a6d7-4bb4-9d36-4d1c98564071)"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "175.63 129.63 120.4 184.87 72.89 137.36 138.25 92.25 175.63 129.63",
    opacity: 0.2,
    fill: "url(#1d9f1c16-9270-471e-acb6-27b8d0fb7285)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M135,89.17,86.41,53c-3.13-2.57-6.27-3.18-9.35-1.83A8.69,8.69,0,0,0,72,58.78,2,2,0,0,0,72,59v74a8.47,8.47,0,0,0,8,8.53h.24a8.32,8.32,0,0,0,5.08-1.73l.86-.64,47.51-35.32,1.36-1A8.18,8.18,0,0,0,135,89.17Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.07,100.3l-1.36,1L86.2,136.64l-.86.64A8.32,8.32,0,0,1,80.26,139H80a8.47,8.47,0,0,1-8-8.53V133a8.47,8.47,0,0,0,8,8.53h.24a8.32,8.32,0,0,0,5.08-1.73l.86-.64,47.51-35.32,1.36-1a8.07,8.07,0,0,0,3.52-8A8.19,8.19,0,0,1,135.07,100.3Z",
    transform: "translate(0 0)",
    opacity: 0.12
  })))))));
}

var _default = ic_play__dark;
exports.default = _default;